import { useEffect } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { useCaseTabs } from '@lp/core/hooks/useCaseTabs';
import { useTitleParams } from '@/routing/document-title';

export const CaseRouteLayout = () => {
  const { caseId } = useParams<{ caseId: string }>();
  const location = useLocation();
  const { onCasePathVisited, tabsList } = useCaseTabs();
  const { setTitleParams } = useTitleParams();

  const tab = tabsList.find((t) => t.id === caseId);
  const unosId = tab ? `${tab.donorId} ${tab.caseSuffixes}`.trim() : 'Case';

  useEffect(() => {
    setTitleParams({ unosId });
  }, [unosId, setTitleParams]);

  useEffect(() => {
    if (!caseId) return;
    onCasePathVisited(caseId, location.pathname + location.search);
  }, [caseId, location.pathname, location.search, onCasePathVisited]);

  return <Outlet />;
};
